<div class="header">
  <span class="close-icon" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </span>
  <!-- Select the post to be published on -->
  <h2 mat-dialog-title class="title-orange">
    {{
      "brand.campaign.contentCalendar.selectThePostToBePublished" | translate
    }}
  </h2>
  <div
    (click)="checkLink($event)"
    class="can-not-save-post-warning"
    [innerHTML]="
      'brand.campaign.contentCalendar.canNotCreateGoogleAdsWarning' | translate
    "
    *ngIf="canNotCreateGoogleAdWarning()"
  ></div>
  <div
    class="can-not-save-post-warning"
    *ngIf="hasReachedMaxNumberOfAds() && !canNotCreateGoogleAdWarning()"
  >
    {{ "brand.campaign.contentCalendar.maxAmountOfAdsReached" | translate }}
  </div>
</div>
<mat-dialog-content>
  <div class="posts-container" *ngIf="selectedCategory">
    <mat-form-field class="category-selector">
      <mat-label>{{
        "brand.campaign.contentCalendar.selectCategory" | translate
      }}</mat-label>
      <mat-select
        (ngModelChange)="onCategoryChanged()"
        [(ngModel)]="selectedCategory"
      >
        <mat-option *ngFor="let category of categories" [value]="category">{{
          category?.title
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <app-brand-campaign-content-calendar-posts-carousel
      (currentItem)="slideChanged($event)"
    >
      <ng-container *ngFor="let post of selectedCategory.posts">
        <ng-container *brandCampaignContentCalendarPostsCarouselItem>
          <ng-container *ngIf="post.isFacebookPost">
            <app-facebook-post-mock-up
              *ngIf="showFacebookPreview(post)"
              [post]="post"
            />
            <app-instagram-post-mock-up
              *ngIf="showInstagramPreview(post)"
              [post]="post"
            />
          </ng-container>
          <app-google-ad-mock-up *ngIf="post.isGoogleAd" [post]="post" />
          <app-linkedin-post-mock-up
            *ngIf="post.isLinkedInPost"
            [post]="post"
          />
        </ng-container>
      </ng-container>
    </app-brand-campaign-content-calendar-posts-carousel>
    <div class="carousel-footer-container">
      <div class="carousel-footer">
        <div class="carousel-footer-preview-text">
          <ng-container *ngIf="showMediaPreviewButton()">
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Facebook"
              src="/assets/images/icons/ic_facebook.svg"
            />
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Instagram"
              src="/assets/images/icons/ic_instagram.svg"
            />
            <span *ngIf="facebookPreviewType === FacebookPreviewType.Facebook">
              {{ "shared.facebookPreview" | translate }}
            </span>
            <span *ngIf="facebookPreviewType === FacebookPreviewType.Instagram">
              {{ "shared.instagramPreview" | translate }}
            </span>
          </ng-container>
        </div>
        <div class="carousel-footer-dots">
          <span
            *ngFor="let post of selectedCategory.posts; let dotsIndex = index"
            [ngClass]="{
              'carousel-footer-dots-dot--selected': dotsIndex === selectedIndex
            }"
            class="carousel-footer-dots-dot"
          ></span>
        </div>
        <div class="carousel-footer-button">
          <button
            *ngIf="showMediaPreviewButton()"
            (click)="toggleFacebookPreviewType()"
            class="carousel-footer-button-preview"
          >
            <span>{{ "shared.preview" | translate }}</span>
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Facebook"
              src="/assets/images/icons/ic_instagramContent.svg"
            />
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Instagram"
              src="/assets/images/icons/ic_facebookContent.svg"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="post-attributes">
      <section class="time-selection">
        <div class="time">
          <label class="selector-title">{{
            "brand.campaign.contentCalendar.chooseTime" | translate
          }}</label>
          <div class="selectors">
            <mat-form-field>
              <mat-label>{{ "shared.hours" | translate }}</mat-label>
              <mat-select [(ngModel)]="scheduledPublishDateHour">
                <mat-option *ngFor="let hour of hours" [value]="hour">
                  {{ hour }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ "shared.minutes" | translate }}</mat-label>
              <mat-select [(ngModel)]="scheduledPublishDateMinute">
                <mat-option *ngFor="let minute of minutes" [value]="minute">
                  {{ minute }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="timezone">
          <label class="selector-title">{{
            "shared.chooseTimezone" | translate
          }}</label>
          <mat-form-field>
            <mat-label>{{ "shared.timezone" | translate }}</mat-label>
            <mat-select [(ngModel)]="scheduledPublishDateTimezone">
              <mat-option *ngFor="let timezone of timezones" [value]="timezone">
                {{ timezone }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </section>

      <ng-container *ngIf="getSelectedPost()?.isFacebookPost">
        <section class="promo-ads">
          <span class="title"
            >{{ "shared.promoAds" | translate }}
            <app-tooltip
              text="{{
                'brand.campaign.contentCalendar.promoAdsToolTip'
                  | translate: { numberOfAds: campaign.maxAdsCampaignPartner }
              }}"
            />
          </span>
          <mat-checkbox
            (change)="calculateNumberOfAdsCreated()"
            [disabled]="
              (!willBecomeAd &&
                numberOfAdsCreated >= campaign.maxAdsCampaignPartner) ||
              isCreateAdNotAllowed
            "
            [(ngModel)]="willBecomeAd"
            name="use-promo-ads-check"
          >
            {{
              "brand.campaign.contentCalendar.usePromoAdsInThisPost" | translate
            }}
            <span class="amount-of-ads">
              ({{ numberOfAdsCreated }}
              {{
                "brand.campaign.contentCalendar.useOutOfAMaximumAmountOff"
                  | translate
              }}
              {{ campaign.maxAdsCampaignPartner }})</span
            >
          </mat-checkbox>
        </section>

        <section *ngIf="canCreateDarkPost()" class="dark-post">
          <span class="title"
            >{{ "shared.darkPost" | translate }}
            <app-tooltip
              text="{{
                'brand.campaign.contentCalendar.darkPostToolTip' | translate
              }}"
            />
          </span>
          <mat-checkbox
            [disabled]="!willBecomeAd"
            [(ngModel)]="isDarkPost"
            name="dark-post-check"
          >
            {{
              "brand.campaign.contentCalendar.onlyUseThisPostForAnAd"
                | translate
            }}
          </mat-checkbox>
        </section>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="button-light-grey button-cancel" [mat-dialog-close]="false">
    {{ "shared.cancel" | translate }}
  </button>
  <button
    [disabled]="!canSave()"
    class="button-orange button-confirm"
    (click)="onSelectPost()"
  >
    <span *ngIf="!selecting">{{ "shared.selectPost" | translate }}</span>
    <span *ngIf="selecting">{{ "shared.saving" | translate }}</span>
  </button>
</mat-dialog-actions>
